module.exports = __webpack_public_path__ + "img/markets-top-bg.30ae7737.png";